import { render } from "./DeleteOrganizationDialog.vue?vue&type=template&id=7876995d"
import script from "./DeleteOrganizationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteOrganizationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__